export enum IntegrationTypes
{
    None = 0,
    Elite = 1,
    Enterprise = 2,
    WeTrackApiUser = 3,
    MomentusConnect = 4
}
